import {
  BUSCA_ENTREVERO,
  LISTA_LOTES_POR_PASTO,
} from "../../../redux/actions/actionsConstants";

export const initialState = {
  LotesPorPasto: [],
  lotesComEntrevero: [],
  saldoDeEntreveroPorLote: {},
};

/**
 * @deprecated in favor of typescript reducer: livestockReducer.ts (not fully migrated)
 */
export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LISTA_LOTES_POR_PASTO:
      return { ...state, LotesPorPasto: payload.LotesPorPasto };
    case BUSCA_ENTREVERO:
      return {
        ...state,
        lotesComEntrevero: payload.lotesComEntrevero,
        saldoDeEntreveroPorLote: payload.saldoDeEntreveroPorLote,
      };
    default:
      return state;
  }
};
